export const DEFAULT_POLICY = 'B2C_1A_SEW_SUSI_HRD';
